exports.Piece = {
    EMPTY : 0,
    PAWN_WHITE : 1,
    PAWN_BLACK : 2,
    DAME_WHITE : 3,
    DAME_BLACK : 4
};

exports.Color = {
    NONE : 0,
    WHITE : 1,
    BLACK : 2
};



//////////////////
// WEBPACK FOOTER
// ./~/draughts-reader-core/src/utils/symbols.js
// module id = bgfr
// module chunks = 4